import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  const current = ref<'layby' | 'plans' | 'boost'>('layby');
  const mode = ref<'shopper' | 'business'>('shopper');

  // Reactively update <html> tag to reflect current product and mode
  watch(
    current,
    (val) => {
      document.documentElement.dataset.product = val;
    },
    { immediate: true },
  );

  watch(
    mode,
    (val) => {
      document.documentElement.dataset.mode = val;
    },
    { immediate: true },
  );

  const setProduct = (product: 'layby' | 'plans' | 'boost') => {
    current.value = product;
  };

  const setMode = (newMode: 'shopper' | 'business') => {
    mode.value = newMode;
  };

  return { current, mode, setProduct, setMode };
});
